import { Link } from "react-router-dom";
import { Cross } from "lucide-react";
import { LOGO_URL } from "@/lib/branding";

const COLS = [
  {
    title: "Community",
    links: [
      { to: "/feed", label: "Feed" },
      { to: "/groups", label: "Prayer Groups" },
      { to: "/memories", label: "Memories" },
      { to: "/testimonies", label: "Testimonies" },
      { to: "/events", label: "Events" },
      { to: "/book-club", label: "Book Club" },
      { to: "/love-thy-elder", label: "Love Thy Elder" },
    ],
  },
  {
    title: "Discover",
    links: [
      { to: "/about", label: "About JJU" },
      { to: "/how-it-works", label: "How it works" },
      { to: "/family", label: "The Family" },
      { to: "/shop", label: "Shop" },
      { to: "/confidence-arise", label: "Confidence Arise" },
      { to: "/million-dollar-mindset", label: "Million Dollar Mindset" },
      { to: "/pricing", label: "Membership" },
      { to: "/donate", label: "Give" },
      { to: "/emergency-help", label: "Emergency help" },
    ],
  },
  {
    title: "Support",
    links: [
      { to: "/faq", label: "FAQ" },
      { to: "/contact", label: "Contact" },
      { to: "/terms", label: "Terms of Service" },
      { to: "/privacy", label: "Privacy Policy" },
      { to: "/guidelines", label: "Community Guidelines" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="border-t border-jj bg-cream mt-16">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-12 grid grid-cols-2 sm:grid-cols-4 gap-10">
        <div className="col-span-2 sm:col-span-1">
          <div className="flex items-center gap-3">
            <span className="h-10 w-10 rounded-full bg-jjblue flex items-center justify-center overflow-hidden ring-1 ring-[var(--jj-gold)]/40">
              <img src={LOGO_URL} alt="Jesus Just Us" className="h-9 w-9 object-contain" />
            </span>
            <span className="font-serif text-xl text-jjblue">Jesus<span className="text-burgundy"> Just </span>Us</span>
          </div>
          <p className="mt-4 text-xs text-[var(--jj-muted)] leading-relaxed">
            One Faith. One Family. One Mission.<br />
            A Kingdom community platform — built with love for the body of Christ.
          </p>
          <a href="mailto:connect@jesusjustus.us" className="mt-4 inline-block text-xs text-burgundy hover:underline" data-testid="footer-email">
            connect@jesusjustus.us
          </a>
        </div>
        {COLS.map((c) => (
          <div key={c.title}>
            <div className="overline text-burgundy mb-3">{c.title}</div>
            <ul className="space-y-2">
              {c.links.map((l) => (
                <li key={l.to}>
                  <Link to={l.to} className="text-sm text-jjblue/80 hover:text-burgundy transition-colors" data-testid={`footer-${l.to.slice(1) || "home"}`}>
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div className="border-t border-jj py-5 text-center text-xs text-[var(--jj-muted)] px-6">
        © {new Date().getFullYear()} Jesus Just Us · Made with love for the body of Christ
        <span className="hidden sm:inline"> · </span>
        <span className="block sm:inline">In an emergency, please call 911 — we are not an emergency service.</span>
      </div>
    </footer>
  );
}
